import StyledText from "./StyledText";
import HeaderTextProps from "./HeaderTextProps";

const H2 = (props: HeaderTextProps) => {
	return (
		// @ts-ignores
		<StyledText fontSize={37} fontWeight={props.fontWeight} {...props}>
			{props.children}
		</StyledText>
	);
};

export default H2;
